// @flow
import React from 'react';

import { OptionProps, OptionProp } from 'app/common/ui-next/option-props';

import styles from './OrderFooter.module.scss';;


type Props = {
  address: ?string,
  comment: ?string,
  t: (s: string) => string,
};

const OrderFooter = ({
  address,
  comment,
  t,
}: Props) => (
  <OptionProps className={styles.column}>

    {address
      && <OptionProp title={t('delivery_address')}>
        {address}
      </OptionProp>}

    {comment
      && <OptionProp title={t('comment')}>
        {comment}
      </OptionProp>}

  </OptionProps>
);

export default OrderFooter;
